var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable } from "aurelia-templating";
var TagsInputFilter = /** @class */ (function () {
    function TagsInputFilter() {
        this.tags = [];
        this.maxNumberOfTags = 10;
        this.tagMaxLength = 30;
        this.disabled = false;
        this.readonly = false;
        this.allowAdd = true;
    }
    TagsInputFilter.prototype.onKeyDownForTag = function ($event) {
        if (this.disabled) {
            return false;
        }
        var element = this.input;
        if (element.value && element.value.length > 0) {
            if ($event.code === "Enter") {
                this.pushNewTag(element.value);
                element.value = null;
            }
            element.size = element.value.length + 1;
        }
        return true;
    };
    TagsInputFilter.prototype.focus = function () {
        if (this.input)
            this.input.focus();
    };
    TagsInputFilter.prototype.stopPropagation = function ($event) {
        $event.stopPropagation();
    };
    TagsInputFilter.prototype.pushNewTag = function (tag) {
        if (!this.allowAdd)
            return;
        if (!this.tags.some(function (x) { return x === tag; }) && tag && tag.length > 0) {
            this.tags.push(tag);
        }
    };
    TagsInputFilter.prototype.remove = function ($event, $index) {
        $event.stopPropagation();
        this.tags.splice($index, 1);
    };
    TagsInputFilter.prototype.onFocus = function ($event) {
        if (this.disabled) {
            return false;
        }
        this.input.size = 1;
        return true;
    };
    TagsInputFilter.prototype.onBlur = function ($event) {
        var element = this.input;
        this.input.size = 1;
        this.pushNewTag(element.value);
        element.value = null;
    };
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], TagsInputFilter.prototype, "tags", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], TagsInputFilter.prototype, "maxNumberOfTags", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], TagsInputFilter.prototype, "tagMaxLength", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], TagsInputFilter.prototype, "label", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], TagsInputFilter.prototype, "disabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], TagsInputFilter.prototype, "readonly", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], TagsInputFilter.prototype, "allowAdd", void 0);
    return TagsInputFilter;
}());
export { TagsInputFilter };
